function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAuth = function SvgAuth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 662.17 900.62"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.11 900.62h157.76C549.3 865.49 651.72 740.06 651.72 590.7 651.72 414.12 508.57 271 332 271S12.26 414.12 12.26 590.7c0 149.36 102.42 274.79 240.85 309.92",
    style: {
      fill: "#c0ddff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.26 900.62v-56.84a76.07 76.07 0 0 0-38-65.86l-10.54-6.08c-14.47-7.42-24.09-22.25-26.9-41.77l-.9-9.27a65.2 65.2 0 0 0-24.16-44.58l-7.48-6A54.33 54.33 0 0 1 472 625.05l.84-16.38a108.64 108.64 0 0 0-15.93-62.41l-15.81-25.75a76 76 0 0 1-10.33-28l-1.5-9.53c-5.16-32.92-27-60.46-57.23-74.35-9.73-4.46-24.14-7.63-40-7.77-15.86.14-30.27 3.31-40 7.77-30.28 13.89-52.07 41.43-57.23 74.35l-1 6.23a43.45 43.45 0 0 1-18.13 28.94l-10.31 7.17A43.43 43.43 0 0 0 186.69 561v11.77a43.45 43.45 0 0 1-20.54 36.92l-9.15 5.67a43.45 43.45 0 0 0-20.53 36.92v31.07a85.33 85.33 0 0 1-34.82 68.77A92.88 92.88 0 0 0 63.72 827v73.61Z",
    style: {
      fill: "#002a66"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m499.52 711.07-71.9-28c-31-12.08-52.46-41.34-55-75.13l-7.2-94.71h-66.84l-7.2 94.77c-2.57 33.79-24 63-55 75.13l-71.9 28a88.45 88.45 0 0 0-52.12 64.76l-15.8 124.73h470.86l-15.78-124.79a88.47 88.47 0 0 0-52.12-64.76",
    style: {
      fill: "#366aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 632c15.16 0 29.37-7.12 41.12-19.25-.21-1.6-.39-3.21-.51-4.84l-7.2-94.71h-66.83l-7.2 94.8c-.12 1.63-.3 3.24-.51 4.84C302.61 624.92 316.83 632 332 632",
    style: {
      fill: "#004add"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.66 508c0 58.89-33.64 106.56-73.67 106.56S258.32 566.84 258.32 508s23.75-98.43 73.67-98.43 73.67 39.48 73.67 98.43",
    style: {
      fill: "#366aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.57 441c-.26.43-.52.86-.77 1.29q-.58 1-1.14 2v.05a90 90 0 0 0-5 11.08v.05c-.28.74-.55 1.49-.82 2.25 0 .07 0 .14-.07.21-.25.72-.5 1.45-.73 2.19 0 .07-.05.14-.08.22-.25.78-.49 1.56-.72 2.35v.05c-.74 2.48-1.4 5-2 7.66v.25c-.17.76-.34 1.52-.5 2.29 0 .16-.06.32-.1.48-.14.71-.28 1.43-.41 2.15 0 .18-.07.35-.1.53-.14.74-.27 1.48-.39 2.23 0 .14-.05.29-.07.43q-.22 1.34-.42 2.67c0 .2-.06.4-.08.61-.14.94-.26 1.89-.38 2.85l-.06.55c-.1.8-.19 1.6-.27 2.41 0 .21-.05.42-.07.64-.09.85-.16 1.71-.24 2.57v.41c-.09 1-.17 2.06-.24 3.1-.06 1-.12 2-.17 3v.85l-.09 2.21v1c0 .73 0 1.47-.05 2.21v8.19c0 .72 0 1.45.07 2.17 0 .39 0 .78.05 1.17 0 .6.06 1.19.1 1.79l.09 1.47c0 .31.05.62.07.93a140.7 140.7 0 0 0 8.52 39l3.76-13a53.08 53.08 0 0 1 25.83-32c36-19.33 74.43-47.64 74.43-93.06-.63-.43-1.28-.85-1.93-1.25l-.32-.19c-.53-.33-1.06-.65-1.61-.95l-.5-.29-1.54-.83-.48-.25q-2-1-4.16-1.92l-.43-.18-1.7-.67-.62-.22-1.65-.58-.53-.18H356c-.73-.24-1.46-.46-2.2-.67-.76-.21-1.53-.42-2.31-.61l-.61-.14q-.86-.21-1.74-.39l-.77-.16-1.71-.32-.72-.13c-.78-.13-1.57-.25-2.37-.35h-.07c-.83-.11-1.66-.21-2.5-.29l-.76-.07-1.81-.15h-.89c-.6 0-1.21-.07-1.82-.09h-3.45c-1 0-1.9 0-2.84.05h-.81c-.72 0-1.44.06-2.14.11h-.71q-1.37.11-2.7.24l-.5.06-2.19.28-.78.11q-1.08.17-2.13.36l-.48.08c-.85.16-1.68.34-2.51.52l-.64.15c-.64.15-1.27.31-1.9.48l-.7.18c-.81.23-1.61.46-2.39.71-1.93.61-3.79 1.3-5.6 2.06a60 60 0 0 0-8.59 4.47c-.57.36-1.14.73-1.69 1.11l-.56.38-1.11.79-.64.47-1 .75-.65.53-.94.76-.65.55-.91.8-.62.56-.91.86-.57.55c-.33.32-.65.65-1 1l-.47.48c-.47.5-.94 1-1.4 1.51-.86 1-1.69 2-2.5 3s-1.6 2.07-2.36 3.15c-.38.54-.75 1.08-1.12 1.64-.85.81-1.42 1.73-1.99 2.63",
    style: {
      fill: "#004add"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.12 407.29-1.16-.51c1.65 32.94 13.8 72 39.86 103.64 12 14.56 27.43 24.1 41.61 33.87a90 90 0 0 0-10-23L422.32 500a63.1 63.1 0 0 1-8.55-23.2l-1.24-7.9c-4.28-27.3-22.32-50.11-47.41-61.61",
    style: {
      fill: "#002a66"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.19 512.36a20.5 20.5 0 0 0-6.57-.72v.3a108.7 108.7 0 0 1-5 33.46c8.54.38 17.37-4.37 21.16-11.92 4.43-8.92.15-18.38-9.59-21.12",
    style: {
      fill: "#366aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.11 471.43A186 186 0 0 0 252 497v.08a154 154 0 0 0 3.92 51.84l5.22-13.2a53.12 53.12 0 0 1 28.72-29.46c37.65-15.87 78.57-40.45 82.83-85.67-.6-.49-1.2-1-1.81-1.43l-.29-.21c-.5-.38-1-.75-1.52-1.11l-.48-.33c-.48-.33-1-.65-1.46-1l-.44-.29q-1.94-1.22-4-2.31l-.41-.21c-.54-.28-1.08-.56-1.63-.83l-.6-.28-1.58-.73-.56-.24c-.71-.31-1.41-.6-2.13-.88-.74-.29-1.5-.57-2.26-.83l-.58-.2c-.56-.19-1.13-.38-1.7-.55l-.74-.23c-.56-.17-1.12-.33-1.69-.48l-.7-.19c-.77-.21-1.54-.4-2.33-.58h-.06c-.82-.18-1.64-.36-2.47-.52l-.74-.14-1.79-.31-.88-.14c-.6-.1-1.2-.18-1.81-.26l-.81-.11c-.87-.11-1.75-.2-2.64-.29a77.5 77.5 0 0 0-23.65 1.19 65 65 0 0 0-7.62 2.15 60 60 0 0 0-7.1 3 60.9 60.9 0 0 0-14.07 9.81 69 69 0 0 0-5.41 5.63c-.43.51-.86 1-1.27 1.53-.68.84-1.34 1.7-2 2.58-.3.4-.6.81-.89 1.22-7.27 10.21-12.71 23-16.3 37.82Z",
    style: {
      fill: "#002a66"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 578.42 315.37 569a16.4 16.4 0 0 0-.26 2.82 16.88 16.88 0 1 0 33.75 0 17.5 17.5 0 0 0-.25-2.82Z",
    style: {
      fill: "#004add"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.64 775.83a90.2 90.2 0 0 0-6.76-20.83c-.39-.82-.78-1.63-1.18-2.44a90 90 0 0 0-5.42-9.31c-.49-.74-1-1.48-1.52-2.21a88 88 0 0 0-12.38-14 86.9 86.9 0 0 0-24.86-16l-64.16-25c-19.95 56.07-58.75 94.12-103.37 94.12s-83.42-38.05-103.38-94.12l-64.15 25a87 87 0 0 0-30.53 21.64 89 89 0 0 0-6.71 8.35c-.52.73-1 1.47-1.52 2.21-1 1.49-1.94 3-2.85 4.57q-2 3.49-3.75 7.18c-.76 1.64-1.48 3.3-2.14 5-.34.84-.66 1.7-1 2.55a86 86 0 0 0-2.43 7.87c-.47 1.78-.87 3.58-1.23 5.4L96.56 900.62h470.86Z",
    style: {
      fill: "#ffd040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.99 780.21v76.45",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 12
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.36 686.09c-19.95 56.07-58.75 94.12-103.37 94.12s-83.42-38.05-103.38-94.12",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 20
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 357.66,
    cy: 805.03,
    rx: 6.53,
    ry: 6.67,
    style: {
      fill: "#ba1919"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 357.66,
    cy: 839.02,
    rx: 6.53,
    ry: 6.67,
    style: {
      fill: "#ba1919"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.63,
    cy: 521.04,
    r: 26.76,
    style: {
      fill: "#fff",
      fillOpacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.18 547.58a28 28 0 0 0 3.45.23 27 27 0 0 0 2.84-.16l-25.78-40.4a26.7 26.7 0 0 0-2.59 5.75ZM357.41 495.91a26.74 26.74 0 0 0-10.16 6.69l27.95 43.8a26.75 26.75 0 0 0 10.33-6.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.35,
    cy: 521.04,
    r: 26.76,
    style: {
      fill: "#fff",
      fillOpacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.91 547.58a28 28 0 0 0 3.44.23 27 27 0 0 0 2.84-.16l-25.78-40.4a27.2 27.2 0 0 0-2.58 5.73ZM288.14 495.91A26.7 26.7 0 0 0 278 502.6l27.94 43.8a26.8 26.8 0 0 0 10.32-6.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.35,
    cy: 521.04,
    r: 26.76,
    style: {
      fill: "none",
      stroke: "#ffd13f",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.63,
    cy: 521.04,
    r: 26.76,
    style: {
      fill: "none",
      stroke: "#ffd13f",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.86 521.04h-15.75",
    style: {
      fill: "none",
      stroke: "#ffd13f",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.48 854.23h174v46.39h-174z",
    style: {
      fill: "#2da861"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.48 854.23h55.1v46.39h-55.1z",
    style: {
      fill: "#1d874a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.49 865.53h55.1v8.32h-55.1zM123.49 880.99h55.1v8.32h-55.1z",
    style: {
      fill: "#116936"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.59 865.53h118.9v8.32h-118.9zM178.59 880.99h118.9v8.32h-118.9z",
    style: {
      fill: "#1d874a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.84 854.23h40.39v46.39h-40.39z",
    style: {
      fill: "#d0d2d3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.04,
    cy: 877.42,
    r: 15.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.52 880.27a3.45 3.45 0 0 1-1.26 2.79 6.25 6.25 0 0 1-3.51 1.26v2.24h-1.5v-2.2a12 12 0 0 1-4.67-.94v-2.88a12.7 12.7 0 0 0 2.28.83 13 13 0 0 0 2.39.43v-3.39l-.73-.28a8.4 8.4 0 0 1-3.07-1.85 3.62 3.62 0 0 1-.9-2.48 3.24 3.24 0 0 1 1.24-2.6 6.3 6.3 0 0 1 3.46-1.24v-1.67h1.5v1.62a12.5 12.5 0 0 1 4.52 1l-1 2.55a12.2 12.2 0 0 0-3.49-.85v3.22a17 17 0 0 1 3 1.42 4.16 4.16 0 0 1 1.32 1.33 3.27 3.27 0 0 1 .42 1.69m-7.68-6.47a1 1 0 0 0 .34.8 4 4 0 0 0 1.07.63v-2.56c-.94.13-1.41.51-1.41 1.13m4.39 6.63a1 1 0 0 0-.37-.77 4.8 4.8 0 0 0-1.11-.66v2.72c.99-.17 1.48-.6 1.48-1.29",
    style: {
      fill: "#1d874a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.08 854.23h174v46.39h-174z",
    style: {
      fill: "#2da861"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.08 854.23h55.1v46.39h-55.1z",
    style: {
      fill: "#1d874a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.08 865.53h55.1v8.32h-55.1zM247.08 880.99h55.1v8.32h-55.1z",
    style: {
      fill: "#116936"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.18 865.53h118.9v8.32h-118.9zM302.18 880.99h118.9v8.32h-118.9z",
    style: {
      fill: "#1d874a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.43 854.23h40.39v46.39h-40.39z",
    style: {
      fill: "#d0d2d3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361.63,
    cy: 877.42,
    r: 15.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.11 880.27a3.47 3.47 0 0 1-1.25 2.79 6.3 6.3 0 0 1-3.52 1.26v2.24h-1.5v-2.2a12 12 0 0 1-4.67-.94v-2.88a12.5 12.5 0 0 0 2.29.83 12.7 12.7 0 0 0 2.38.43v-3.39l-.73-.28a8.3 8.3 0 0 1-3.06-1.85 3.57 3.57 0 0 1-.9-2.48 3.21 3.21 0 0 1 1.24-2.6 6.2 6.2 0 0 1 3.45-1.24v-1.67h1.5v1.62a12.5 12.5 0 0 1 4.52 1l-1 2.55a12.2 12.2 0 0 0-3.49-.85v3.22a17 17 0 0 1 3 1.42 4.16 4.16 0 0 1 1.32 1.33 3.27 3.27 0 0 1 .42 1.69m-7.68-6.47a1 1 0 0 0 .34.8 4.2 4.2 0 0 0 1.07.63v-2.56c-.94.13-1.41.51-1.41 1.13m4.39 6.63a1 1 0 0 0-.37-.77 4.6 4.6 0 0 0-1.11-.66v2.72c.99-.17 1.48-.6 1.48-1.29",
    style: {
      fill: "#1d874a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.87 854.23h174v46.39h-174z",
    style: {
      fill: "#2da861"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.87 854.23h55.1v46.39h-55.1z",
    style: {
      fill: "#1d874a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.88 865.53h55.1v8.32h-55.1zM370.88 880.99h55.1v8.32h-55.1z",
    style: {
      fill: "#116936"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.97 865.53h118.9v8.32h-118.9zM425.97 880.99h118.9v8.32h-118.9z",
    style: {
      fill: "#1d874a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.23 854.23h40.39v46.39h-40.39z",
    style: {
      fill: "#d0d2d3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 485.42,
    cy: 877.42,
    r: 15.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.91 880.27a3.45 3.45 0 0 1-1.26 2.79 6.3 6.3 0 0 1-3.52 1.26v2.24h-1.49v-2.2a12 12 0 0 1-4.68-.94v-2.88a13 13 0 0 0 2.29.83 13 13 0 0 0 2.39.43v-3.39l-.73-.28a8.2 8.2 0 0 1-3.07-1.85 3.57 3.57 0 0 1-.9-2.48 3.21 3.21 0 0 1 1.24-2.6 6.3 6.3 0 0 1 3.46-1.24v-1.67h1.49v1.62a12.5 12.5 0 0 1 4.53 1l-1 2.55a12.3 12.3 0 0 0-3.5-.85v3.22a16.7 16.7 0 0 1 3 1.42 4.1 4.1 0 0 1 1.33 1.33 3.27 3.27 0 0 1 .42 1.69m-7.68-6.47a1.06 1.06 0 0 0 .33.8 4.1 4.1 0 0 0 1.08.63v-2.56c-.94.13-1.41.51-1.41 1.13m4.39 6.63a1 1 0 0 0-.37-.77 4.7 4.7 0 0 0-1.12-.66v2.72c.99-.17 1.49-.6 1.49-1.29",
    style: {
      fill: "#1d874a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.78 807.84h174v46.39h-174z",
    style: {
      fill: "#2da861"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.78 807.84h55.1v46.39h-55.1z",
    style: {
      fill: "#1d874a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.78 819.14h55.1v8.32h-55.1zM182.78 834.6h55.1v8.32h-55.1z",
    style: {
      fill: "#116936"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.88 819.14h118.9v8.32h-118.9zM237.88 834.6h118.9v8.32h-118.9z",
    style: {
      fill: "#1d874a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.14 807.84h40.39v46.39h-40.39z",
    style: {
      fill: "#d0d2d3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.33,
    cy: 831.03,
    r: 15.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.81 833.88a3.47 3.47 0 0 1-1.25 2.79 6.3 6.3 0 0 1-3.52 1.26v2.24h-1.49V838a12 12 0 0 1-4.68-.94v-2.88a14.4 14.4 0 0 0 4.68 1.26V832l-.74-.28a8.3 8.3 0 0 1-3.06-1.85 3.6 3.6 0 0 1-.9-2.48 3.25 3.25 0 0 1 1.24-2.61 6.3 6.3 0 0 1 3.46-1.23v-1.68H298v1.63a12.2 12.2 0 0 1 4.52 1l-1 2.55a12 12 0 0 0-3.5-.85v3.22a17 17 0 0 1 3 1.42 4.3 4.3 0 0 1 1.33 1.32 3.4 3.4 0 0 1 .46 1.72m-7.67-6.47a1 1 0 0 0 .33.79 3.9 3.9 0 0 0 1.08.64v-2.57q-1.41.21-1.41 1.14m4.39 6.63a1 1 0 0 0-.37-.78 4.7 4.7 0 0 0-1.12-.65v2.72c.96-.17 1.49-.6 1.49-1.33Z",
    style: {
      fill: "#1d874a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.37 807.84h174v46.39h-174z",
    style: {
      fill: "#2da861"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.37 807.84h55.1v46.39h-55.1z",
    style: {
      fill: "#1d874a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.38 819.14h55.1v8.32h-55.1zM306.38 834.6h55.1v8.32h-55.1z",
    style: {
      fill: "#116936"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.47 819.14h118.9v8.32h-118.9zM361.47 834.6h118.9v8.32h-118.9z",
    style: {
      fill: "#1d874a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.73 807.84h40.39v46.39h-40.39z",
    style: {
      fill: "#d0d2d3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420.92,
    cy: 831.03,
    r: 15.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.41 833.88a3.48 3.48 0 0 1-1.26 2.79 6.3 6.3 0 0 1-3.52 1.26v2.24h-1.49V838a12 12 0 0 1-4.68-.94v-2.88a13 13 0 0 0 2.29.83 13 13 0 0 0 2.39.43V832l-.73-.28a8.2 8.2 0 0 1-3.07-1.85 3.6 3.6 0 0 1-.9-2.48 3.25 3.25 0 0 1 1.24-2.61 6.3 6.3 0 0 1 3.46-1.23v-1.68h1.49v1.63a12.3 12.3 0 0 1 4.53 1l-1 2.55a12 12 0 0 0-3.5-.85v3.22a17 17 0 0 1 3 1.42 4.1 4.1 0 0 1 1.33 1.32 3.3 3.3 0 0 1 .42 1.72m-7.68-6.47a1 1 0 0 0 .33.79 3.9 3.9 0 0 0 1.08.64v-2.57q-1.41.21-1.41 1.14m4.39 6.63a1 1 0 0 0-.37-.78 4.7 4.7 0 0 0-1.12-.65v2.72c.99-.17 1.49-.6 1.49-1.33Z",
    style: {
      fill: "#1d874a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.58 761.44h174v46.39h-174z",
    style: {
      fill: "#2da861"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.58 761.44h55.1v46.39h-55.1z",
    style: {
      fill: "#1d874a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.58 772.75h55.1v8.32h-55.1zM244.58 788.21h55.1v8.32h-55.1z",
    style: {
      fill: "#116936"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.68 772.75h118.9v8.32h-118.9zM299.68 788.21h118.9v8.32h-118.9z",
    style: {
      fill: "#1d874a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.93 761.44h40.39v46.39h-40.39z",
    style: {
      fill: "#d0d2d3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.13,
    cy: 784.64,
    r: 15.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.61 787.48a3.45 3.45 0 0 1-1.26 2.79 6.2 6.2 0 0 1-3.51 1.27v2.24h-1.5v-2.2a12.2 12.2 0 0 1-4.67-.94v-2.88a12.5 12.5 0 0 0 2.29.83 12 12 0 0 0 2.38.42v-3.38l-.73-.29a8.14 8.14 0 0 1-3.07-1.85 3.6 3.6 0 0 1-.9-2.47 3.23 3.23 0 0 1 1.25-2.61 6.3 6.3 0 0 1 3.45-1.24v-1.67h1.5v1.63a12.3 12.3 0 0 1 4.52 1l-1 2.55a11.9 11.9 0 0 0-3.49-.85v3.22a17 17 0 0 1 3 1.42 4.14 4.14 0 0 1 1.32 1.32 3.27 3.27 0 0 1 .42 1.69m-7.68-6.48a1 1 0 0 0 .34.79 4 4 0 0 0 1.07.64v-2.57q-1.41.23-1.41 1.14m4.39 6.63a1 1 0 0 0-.37-.78 4.8 4.8 0 0 0-1.11-.65v2.72c.99-.15 1.48-.58 1.48-1.27Z",
    style: {
      fill: "#1d874a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.52 484.75h158.8v49.61h-158.8z",
    style: {
      fill: "#fff"
    },
    transform: "rotate(17.08 554.793 509.39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.17 418.29h24.8v158.8h-24.8z",
    style: {
      fill: "#ecf2fa"
    },
    transform: "matrix(.29 -.96 .96 .29 -81.2 885.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.88 471.13 22 6.77 3.69-12-25.92-8A17.34 17.34 0 0 0 471 469.39l-8 26.3a17.35 17.35 0 0 0 11.49 21.67l25.92 8 3.7-12-22.11-6.84a8.81 8.81 0 0 1-5.83-11l5.7-18.52a8.81 8.81 0 0 1 11.01-5.87",
    style: {
      fill: "#edb20a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.59 472.25h12.59v133.22h-12.59z",
    style: {
      fill: "#ffd040"
    },
    transform: "rotate(-72.92 565.942 538.867)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.16 424.83h12.59v133.22h-12.59z",
    style: {
      fill: "#ffd040"
    },
    transform: "rotate(-72.92 580.504 491.451)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.99 390.66h27.99v148.4h-27.99z",
    style: {
      fill: "#2da75f"
    },
    transform: "rotate(-72.92 563.04 464.853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.91 478.08h27.99v3.61h-27.99z",
    style: {
      fill: "#ffd13f"
    },
    transform: "rotate(-72.92 611.964 479.88)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.73 475.87h27.99v3.61h-27.99z",
    style: {
      fill: "#ffd13f"
    },
    transform: "matrix(.29 -.96 .96 .29 -29.46 915.48)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.03 450.16h27.99v3.61h-27.99z",
    style: {
      fill: "#ffd13f"
    },
    transform: "rotate(-72.92 521.08 451.969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.85 447.96h27.99v3.61h-27.99z",
    style: {
      fill: "#ffd13f"
    },
    transform: "rotate(-72.92 513.897 449.769)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.17 459.69a7.59 7.59 0 1 1-5-9.49 7.61 7.61 0 0 1 5 9.49m-11.68-3.59a4.62 4.62 0 1 0 5.78-3.06 4.63 4.63 0 0 0-5.78 3.06",
    style: {
      fill: "#ffd13f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.41 367.03h27.99v148.4h-27.99z",
    style: {
      fill: "#002a66"
    },
    transform: "rotate(-72.92 581.457 441.23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.33 454.45h27.99v3.61h-27.99z",
    style: {
      fill: "#c0e0fd"
    },
    transform: "rotate(-72.92 630.375 456.252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.14 452.24h27.99v3.61h-27.99z",
    style: {
      fill: "#c0e0fd"
    },
    transform: "matrix(.29 -.96 .96 .29 6.14 916.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.45 426.53h27.99v3.61h-27.99z",
    style: {
      fill: "#c0e0fd"
    },
    transform: "rotate(-72.92 539.497 428.345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.27 424.33h27.99v3.61h-27.99z",
    style: {
      fill: "#c0e0fd"
    },
    transform: "rotate(-73.2 528.103 424.82)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.59 436.06a7.59 7.59 0 1 1-5-9.49 7.6 7.6 0 0 1 5 9.49m-11.68-3.59a4.62 4.62 0 1 0 5.78-3.06 4.63 4.63 0 0 0-5.78 3.06",
    style: {
      fill: "#c0e0fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.49 388.55h132.28v33.68H520.49z",
    style: {
      fill: "#fff"
    },
    transform: "rotate(16.8 593.212 411.977)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m521 376.94-2.32 7.57 131.18 40.3 4.95-16.1L532.13 371a8.91 8.91 0 0 0-11.13 5.94",
    style: {
      fill: "#ecf2fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m545.13 405.08-21.43-6.59a4 4 0 0 1-2.62-4.95l4.65-15.14a4 4 0 0 1 4.95-2.63l21.43 6.59 2.91-9.48-25.22-7.74a9.91 9.91 0 0 0-12.38 6.56l-7 22.72A9.9 9.9 0 0 0 517 406.8l25.22 7.75Z",
    style: {
      fill: "#ba1919"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.3 370.22h9.91v112.09h-9.91z",
    style: {
      fill: "#d83a3a"
    },
    transform: "rotate(-72.92 597.302 426.27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.19 338.03h9.91v112.09h-9.91z",
    style: {
      fill: "#d83a3a"
    },
    transform: "rotate(-72.92 607.188 394.073)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.79 378.99h137.2v173.63H22.79z",
    style: {
      fill: "#fff"
    },
    transform: "rotate(-17.37 91.423 465.896)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.84 410.18h45.13v10H21.84z",
    style: {
      fill: "#c0e0fd"
    },
    transform: "rotate(-17.38 44.385 415.11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.29 451.81h104.57v10H36.29z",
    style: {
      fill: "#c0e0fd"
    },
    transform: "rotate(-17.38 88.54 456.742)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.65 468.94h104.57v10H41.65z",
    style: {
      fill: "#c0e0fd"
    },
    transform: "rotate(-17.38 93.89 473.863)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.01 486.06h104.57v10H47.01z",
    style: {
      fill: "#c0e0fd"
    },
    transform: "rotate(-17.38 99.273 490.99)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.37 503.18h104.57v10H52.37z",
    style: {
      fill: "#c0e0fd"
    },
    transform: "rotate(-17.38 104.63 508.078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.08 529.18h45.13v10H59.08z",
    style: {
      fill: "#c0e0fd"
    },
    transform: "rotate(-17.38 81.605 534.086)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.13,
    cy: 406.55,
    r: 22.22,
    style: {
      fill: "#2da75f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93 409.36 11.15 5.84 10.45-19.96",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.97,
    cy: 277.35,
    r: 92.68,
    style: {
      fill: "#ff9800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.66 277.35c0-1.68-.05-3.34-.14-5h-57.35a87.53 87.53 0 0 1 29.87-61 92 92 0 0 0-7.54-6.68 97.48 97.48 0 0 0-32.35 67.67H337v-87.53c-1.65-.09-3.32-.14-5-.14s-3.34.05-5 .14v87.54h-20.2a97.5 97.5 0 0 0-32-67.35c.33-.45.65-.91 1-1.36-.45.34-.9.7-1.34 1.05l-.27.23c-1.11.88-2.2 1.8-3.26 2.74l-.6.52c-1.07 1-2.12 1.94-3.15 2.94-.08.09-.18.17-.26.25a92.4 92.4 0 0 0-27.48 61v1l-.06 1.37v5.12c0 .82.06 1.64.1 2.46a92.4 92.4 0 0 0 27.48 61q1.75 1.74 3.62 3.39l.11.09q1.86 1.65 3.81 3.2a92.25 92.25 0 0 0 55 20h5.12l1.37-.05h1A92.2 92.2 0 0 0 389.5 350l.25-.21c1.21-1 2.4-2 3.55-3l.22-.19c1.19-1.06 2.35-2.14 3.48-3.26a93 93 0 0 0 8.65-9.81 95 95 0 0 1-11.31 7.38 87.5 87.5 0 0 1-27.21-58.56h57.35c.13-1.66.18-3.35.18-5m-97.69 5v67.38a92.3 92.3 0 0 1-36.38-18.37 97 97 0 0 0 16.21-49Zm-70.14-22.53a92.2 92.2 0 0 1 12.41-46.33 87.48 87.48 0 0 1 27.54 58.86h-39.11a94 94 0 0 1-.84-12.53m2.76 22.53h37.19a87 87 0 0 1-13.65 42.14 92.47 92.47 0 0 1-23.54-42.14m125.22 63.16a92.7 92.7 0 0 1-47.81 6.14v-69.3h20.18a97.37 97.37 0 0 0 27.63 63.16",
    style: {
      fill: "#ef8006"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 782.2c-3-2.66-6-5.42-8.89-8.2l2.78-2.88c2.84 2.74 5.79 5.46 8.76 8.08Zm-17.4-16.78c-2.76-2.91-5.49-5.93-8.11-9l3-2.61c2.58 3 5.27 5.95 8 8.82Zm-15.82-18.26c-2.49-3.15-4.94-6.4-7.29-9.65l3.25-2.34c2.31 3.21 4.72 6.4 7.17 9.5Zm-14.13-19.61c-2.2-3.36-4.35-6.81-6.39-10.26l3.44-2c2 3.4 4.13 6.8 6.29 10.11Zm-12.31-20.8c-1.89-3.54-3.72-7.17-5.44-10.79l3.61-1.72c1.7 3.57 3.5 7.14 5.36 10.63Zm-10.39-21.81c-1.56-3.7-3-7.48-4.44-11.24l3.75-1.39c1.37 3.71 2.84 7.44 4.37 11.07Zm-8.37-22.67c-1.22-3.82-2.36-7.72-3.41-11.59l3.86-1c1 3.82 2.16 7.66 3.36 11.42Zm-6.28-23.33c-.87-3.91-1.66-7.9-2.35-11.85l3.94-.68c.68 3.89 1.46 7.81 2.31 11.67Zm-4.15-23.79c-.51-4-.94-8-1.27-12l4-.33c.33 3.94.75 7.93 1.25 11.84Zm-2-24.08c-.13-3.45-.2-7-.2-10.43h4c0 3.42.07 6.88.2 10.28ZM73.63 341.18l-4-.25c.13-2 .28-4 .46-6l4 .35c-.18 1.93-.33 3.92-.46 5.9M75.47 323.15l-4-.56c.6-4.2 1.31-8.3 2.13-12.21l3.92.82c-.76 3.8-1.47 7.8-2.05 11.95m5-23.7-3.84-1.12c1.2-4.1 2.56-8.07 4-11.78L84.4 288c-1.4 3.63-2.75 7.47-3.92 11.45Zm75.76-1.6a31.8 31.8 0 0 1-7.73-1 30.5 30.5 0 0 1-4.27-1.42l1.56-3.69a25.4 25.4 0 0 0 3.69 1.23 27.5 27.5 0 0 0 7.46.84l.1 4Zm13.47-3.14-1.78-3.59a26.9 26.9 0 0 0 8.89-7.05l3.09 2.54a31.1 31.1 0 0 1-10.19 8.1Zm-36-6.94a31.4 31.4 0 0 1-6.27-11.4l3.83-1.18a27.4 27.4 0 0 0 5.46 10Zm-44.22-10.64-3.48-1.9a89 89 0 0 1 6.72-10.59l3.17 2.36a83 83 0 0 0-6.41 10.13m96.52-2-3.84-1.13c.18-.58.33-1.17.47-1.77a18 18 0 0 0 .46-4.15 23 23 0 0 0-.61-5.19l3.9-.89a27.4 27.4 0 0 1 .71 6.08 22.5 22.5 0 0 1-.56 5.06c-.16.68-.34 1.35-.53 2Zm-82.26-17.07-2.74-2.88a69 69 0 0 1 9.87-7.87l2.19 3.35a63.4 63.4 0 0 0-9.32 7.41Zm74-5.56a28.6 28.6 0 0 0-8.33-7.79l2.09-3.41a32.55 32.55 0 0 1 9.49 8.87Zm-54.21-7.36-1.51-3.7a68.4 68.4 0 0 1 12.09-3.65l.8 3.91a66 66 0 0 0-11.37 3.45Zm35.14-4.14a70.4 70.4 0 0 0-11.9-.65l-.12-4a72.5 72.5 0 0 1 12.6.69ZM130 263.64l-4-.3a37 37 0 0 1 1-6.26l3.88 1a32 32 0 0 0-.88 5.56M153.07 224.06l-3.29-2.28a45 45 0 0 1 3.94-4.87l2.94 2.7a43 43 0 0 0-3.59 4.45M165 212.3l-2.32-3.25a57 57 0 0 1 10.32-5.88l1.6 3.67a53.8 53.8 0 0 0-9.6 5.46m52.86-5a70 70 0 0 0-10.7-3.3l.87-3.9a74 74 0 0 1 11.28 3.5Zm-32.69-3.77-.76-3.92a54.3 54.3 0 0 1 11.87-1l-.1 4a51.5 51.5 0 0 0-11.04.94ZM233 215.21a87 87 0 0 0-5.05-3l1.95-3.49c1.74 1 3.51 2 5.25 3.14ZM590.35 341.18c-.13-2-.28-4-.45-5.94l4-.35c.18 2 .33 4 .46 6ZM588.51 323.15c-.59-4.12-1.29-8.14-2.09-11.95l3.92-.82c.81 3.9 1.53 8 2.13 12.21Zm-5-23.7c-1.16-4-2.48-7.82-3.91-11.41l3.71-1.49c1.48 3.71 2.84 7.68 4 11.78Zm-75.75-1.6h-.82l.11-4a27.4 27.4 0 0 0 7.46-.84 25.4 25.4 0 0 0 3.69-1.23l1.55 3.69a30.4 30.4 0 0 1-4.26 1.42 31.8 31.8 0 0 1-7.75.96Zm-13.47-3.14a31 31 0 0 1-10.2-8.1l3.09-2.55a27 27 0 0 0 8.88 7.06Zm36-6.94-3-2.62a27.4 27.4 0 0 0 5.46-10l3.82 1.18a31.4 31.4 0 0 1-6.26 11.44Zm44.19-10.63a85 85 0 0 0-6.39-10.14l3.21-2.39a91 91 0 0 1 6.7 10.62Zm-96.52-2c-.2-.66-.38-1.33-.53-2a22 22 0 0 1-.56-5.05 27.4 27.4 0 0 1 .71-6.09l3.9.89a23 23 0 0 0-.61 5.2 18.4 18.4 0 0 0 .45 4.14c.14.6.3 1.19.47 1.77Zm82.25-17.07a63.4 63.4 0 0 0-9.28-7.41l2.19-3.35a68.4 68.4 0 0 1 9.86 7.87Zm-74-5.56-3.21-2.33a32.4 32.4 0 0 1 9.49-8.87l2.09 3.41a28.6 28.6 0 0 0-8.35 7.79Zm54.21-7.36a66 66 0 0 0-11.39-3.44l.8-3.91a68 68 0 0 1 12.09 3.65ZM505.31 241l-.58-4a72.5 72.5 0 0 1 12.59-.69l-.12 4a70.3 70.3 0 0 0-11.89.69M534 263.64a33 33 0 0 0-.91-5.58l3.88-1a37 37 0 0 1 1 6.26ZM510.91 224.06a42 42 0 0 0-3.6-4.45l2.95-2.7a45 45 0 0 1 3.94 4.87ZM499 212.3a53.3 53.3 0 0 0-9.62-5.46l1.6-3.67a57.5 57.5 0 0 1 10.35 5.88Zm-52.85-5-1.48-3.72A74 74 0 0 1 456 200.1l.86 3.9a70 70 0 0 0-10.71 3.32Zm32.69-3.77a51.5 51.5 0 0 0-11-.91l-.1-4a54.4 54.4 0 0 1 11.87 1ZM431 215.21l-2.15-3.37c1.75-1.11 3.51-2.17 5.25-3.14l2 3.49c-1.77.94-3.47 1.95-5.1 3.02M491.14 783l-2.63-3c2.82-2.47 5.63-5 8.35-7.62l2.76 2.9c-2.76 2.58-5.62 5.19-8.48 7.72m17.05-16.26-2.89-2.77c2.74-2.85 5.45-5.8 8.06-8.77l3 2.63c-2.65 2.99-5.36 5.99-8.17 8.88Zm15.94-18.16L521 746c2.48-3.08 4.92-6.27 7.24-9.45l3.23 2.36a229 229 0 0 1-7.34 9.64ZM538.39 729l-3.33-2.21c2.19-3.3 4.33-6.68 6.37-10.07l3.42 2.06c-2.06 3.47-4.24 6.91-6.46 10.22m12.46-20.72-3.52-1.91c1.89-3.48 3.72-7 5.43-10.6l3.6 1.74c-1.74 3.63-3.6 7.26-5.51 10.8Zm10.53-21.76-3.67-1.52c1.56-3.64 3.06-7.36 4.45-11.05l3.74 1.41c-1.41 3.72-2.9 7.5-4.52 11.19Zm8.53-22.63-3.81-1.24c1.23-3.76 2.38-7.59 3.44-11.41l3.85 1.07c-1.07 3.9-2.24 7.8-3.48 11.61Zm6.44-23.31-3.9-.89c.88-3.85 1.68-7.77 2.38-11.68l3.94.72c-.72 3.99-1.53 7.97-2.42 11.88Zm4.3-23.8-4-.54c.53-3.91 1-7.9 1.32-11.84l4 .35c-.33 4.03-.78 8.08-1.32 12.06Zm2.15-24.09-4-.17c.17-3.95.26-7.95.26-11.91h4c.01 4.05-.06 8.11-.26 12.11ZM226.89 33.67h-17.16V2.26h17.16v2h-15v11.9h14.14v2h-14.11v13.49h15ZM247.21 33.67l-.54-3.7h-.17a11.1 11.1 0 0 1-3.62 3.19 9.74 9.74 0 0 1-4.4.94 7.6 7.6 0 0 1-5.35-1.77 6.3 6.3 0 0 1-1.91-4.87 6 6 0 0 1 2.85-5.31c1.9-1.26 4.64-1.93 8.24-2l4.45-.13v-1.54a8 8 0 0 0-1.36-5 5.24 5.24 0 0 0-4.36-1.7 14.5 14.5 0 0 0-6.72 1.81l-.8-1.85a17.85 17.85 0 0 1 7.61-1.81c2.56 0 4.48.67 5.74 2s1.9 3.41 1.9 6.23v15.51Zm-8.6-1.51a8 8 0 0 0 5.9-2.14 8 8 0 0 0 2.16-5.94v-2.29l-4.08.17q-4.92.24-7 1.53a4.44 4.44 0 0 0-2.09 4.05 4.38 4.38 0 0 0 1.32 3.46 5.46 5.46 0 0 0 3.79 1.16M265.09 9.86a18.3 18.3 0 0 1 3.18.3l-.41 2a12.6 12.6 0 0 0-3-.36 5.86 5.86 0 0 0-4.9 2.53 10.32 10.32 0 0 0-1.96 6.45v12.89h-2.1V10.31h1.8l.22 4.21h.15a9.9 9.9 0 0 1 3.07-3.62 7.24 7.24 0 0 1 3.95-1.04M288.87 33.67V18.52q0-3.52-1.49-5.12a6 6 0 0 0-4.59-1.61c-2.8 0-4.84.71-6.14 2.12s-1.94 3.7-1.94 6.87v12.89h-2.13V10.31h1.81l.4 3.2h.13q2.28-3.64 8.1-3.65 8 0 8 8.53v15.28ZM317.76 12.16h-5.5v21.51h-2.12V12.16h-4.34v-1.25l4.34-.79V8.31c0-2.86.52-5 1.58-6.3s2.77-2 5.16-2a13.3 13.3 0 0 1 3.87.58l-.49 1.85a11.4 11.4 0 0 0-3.42-.54 4 4 0 0 0-3.53 1.47 8.4 8.4 0 0 0-1.05 4.78v2.17h5.5ZM341.15 22c0 3.81-.93 6.78-2.77 8.92a9.55 9.55 0 0 1-7.65 3.22 9.93 9.93 0 0 1-5.42-1.49 9.46 9.46 0 0 1-3.58-4.25 15.5 15.5 0 0 1-1.25-6.4q0-5.72 2.77-8.91a9.55 9.55 0 0 1 7.61-3.19 9.38 9.38 0 0 1 7.55 3.23q2.75 3.2 2.74 8.87m-18.43 0q0 4.82 2.11 7.51a8 8 0 0 0 12 0q2.11-2.7 2.11-7.51c0-3.23-.71-5.72-2.13-7.5a7.27 7.27 0 0 0-6-2.67 7.15 7.15 0 0 0-6 2.66c-1.4 1.73-2.09 4.23-2.09 7.51M356.37 9.86a18.3 18.3 0 0 1 3.18.3l-.41 2a12.6 12.6 0 0 0-3-.36 5.86 5.86 0 0 0-4.89 2.53 10.32 10.32 0 0 0-1.92 6.41v12.93h-2.12V10.31H349l.22 4.21h.15a9.9 9.9 0 0 1 3.07-3.62 7.2 7.2 0 0 1 3.93-1.04M370.94 10.31h2.19l4.94 13.11c1.51 4 2.46 6.74 2.86 8.14h.13c.6-1.85 1.58-4.6 2.94-8.27l4.94-13h2.19l-10.46 27.16a20.8 20.8 0 0 1-2.13 4.47 5.8 5.8 0 0 1-2 1.74 6.25 6.25 0 0 1-2.79.58 9.7 9.7 0 0 1-2.73-.45v-1.85a10 10 0 0 0 2.69.34 3.6 3.6 0 0 0 1.93-.51 4.9 4.9 0 0 0 1.52-1.6 22 22 0 0 0 1.57-3.44l1.15-3.06ZM413.92 22c0 3.81-.93 6.78-2.77 8.92a9.55 9.55 0 0 1-7.65 3.22 9.93 9.93 0 0 1-5.42-1.49 9.46 9.46 0 0 1-3.58-4.25 15.5 15.5 0 0 1-1.25-6.4q0-5.72 2.77-8.91a9.54 9.54 0 0 1 7.61-3.19 9.38 9.38 0 0 1 7.55 3.23q2.74 3.2 2.74 8.87m-18.44 0q0 4.82 2.12 7.51a8 8 0 0 0 12 0q2.12-2.7 2.11-7.51c0-3.23-.71-5.72-2.13-7.5a7.27 7.27 0 0 0-6-2.67 7.15 7.15 0 0 0-6 2.66q-2.1 2.61-2.1 7.51M421.79 10.31v15.13c0 2.35.5 4 1.49 5.12a6 6 0 0 0 4.59 1.6q4.17 0 6.14-2.1c1.31-1.41 2-3.69 2-6.86V10.31h2.11v23.36h-1.81l-.38-3.23h-.13q-2.28 3.66-8.1 3.66-8 0-8-8.53V10.31ZM454.65 9.86a18.3 18.3 0 0 1 3.18.3l-.4 2a12.7 12.7 0 0 0-3-.36 5.86 5.86 0 0 0-4.9 2.53 10.32 10.32 0 0 0-1.91 6.41v12.93h-2.13V10.31h1.8l.22 4.21h.15a9.9 9.9 0 0 1 3.07-3.62 7.24 7.24 0 0 1 3.92-1.04M179.92 81.67l-.54-3.7h-.17a11.1 11.1 0 0 1-3.62 3.19 9.74 9.74 0 0 1-4.4.94 7.6 7.6 0 0 1-5.35-1.77 6.3 6.3 0 0 1-1.91-4.87 6 6 0 0 1 2.85-5.31c1.9-1.26 4.64-1.93 8.24-2l4.45-.13v-1.54a8 8 0 0 0-1.36-5 5.24 5.24 0 0 0-4.36-1.7 14.5 14.5 0 0 0-6.75 1.78l-.8-1.85a17.85 17.85 0 0 1 7.61-1.81c2.56 0 4.48.67 5.74 2s1.9 3.41 1.9 6.23v15.54Zm-8.6-1.51a7.44 7.44 0 0 0 8.06-8.08v-2.29l-4.08.21q-4.92.24-7 1.53a4.44 4.44 0 0 0-2.09 4.05 4.38 4.38 0 0 0 1.32 3.42 5.46 5.46 0 0 0 3.79 1.16M197.93 82.1a10 10 0 0 1-7.84-3.16c-1.89-2.11-2.84-5-2.84-8.81s1-6.88 2.95-9a10.36 10.36 0 0 1 8.05-3.23 16.3 16.3 0 0 1 5.81 1l-.59 1.89a17 17 0 0 0-5.26-1 8 8 0 0 0-6.51 2.66c-1.47 1.77-2.21 4.31-2.21 7.64a11.32 11.32 0 0 0 2.21 7.4 7.6 7.6 0 0 0 6.19 2.67A15.2 15.2 0 0 0 203.8 79v2a13.4 13.4 0 0 1-5.87 1.1M218.4 82.1a10 10 0 0 1-7.85-3.16c-1.89-2.11-2.83-5-2.83-8.81s1-6.88 2.94-9a10.37 10.37 0 0 1 8.06-3.23 16.2 16.2 0 0 1 5.8 1l-.58 1.89a17.2 17.2 0 0 0-5.26-1 8 8 0 0 0-6.51 2.66c-1.48 1.77-2.22 4.31-2.22 7.64a11.27 11.27 0 0 0 2.22 7.4 7.57 7.57 0 0 0 6.18 2.67 15.2 15.2 0 0 0 5.91-1.16v2a13.4 13.4 0 0 1-5.86 1.1M248.85 70q0 5.72-2.77 8.92a9.55 9.55 0 0 1-7.65 3.22 9.87 9.87 0 0 1-5.43-1.53 9.5 9.5 0 0 1-3.59-4.25 15.5 15.5 0 0 1-1.25-6.4c0-3.81.93-6.78 2.77-8.91a9.55 9.55 0 0 1 7.61-3.19 9.37 9.37 0 0 1 7.55 3.23q2.77 3.24 2.76 8.91m-18.43 0q0 4.82 2.11 7.51a8 8 0 0 0 12 0q2.12-2.7 2.12-7.51c0-3.23-.72-5.72-2.14-7.5a7.27 7.27 0 0 0-6-2.67 7.17 7.17 0 0 0-6 2.66q-2.08 2.61-2.09 7.51M284.05 81.67V66.35q0-3.42-1.33-5a5.08 5.08 0 0 0-4.08-1.57q-3.58 0-5.31 2c-1.14 1.32-1.72 3.39-1.72 6.21v13.68h-2.17v-16q0-5.91-5.41-5.91c-2.45 0-4.23.72-5.35 2.14S257 65.64 257 68.78v12.89h-2.12V58.31h1.76l.45 3.2h.13a6.66 6.66 0 0 1 2.78-2.69 8.16 8.16 0 0 1 3.93-1q5.52 0 7.09 4.15h.09a7.9 7.9 0 0 1 3.06-3.07 8.77 8.77 0 0 1 4.37-1.08q3.83 0 5.74 2c1.27 1.36 1.91 3.53 1.91 6.49v15.36ZM303.27 82.1q-5.38 0-7.86-4h-.15l.06 1.8q.09 1.59.09 3.48v8.9h-2.13V58.31h1.81l.4 3.33h.13q2.42-3.78 7.69-3.78a8.67 8.67 0 0 1 7.21 3.14c1.66 2 2.48 5.05 2.48 9s-.87 6.81-2.61 8.93a8.74 8.74 0 0 1-7.12 3.17m0-1.89a6.49 6.49 0 0 0 5.55-2.67c1.31-1.77 2-4.26 2-7.45q0-10.29-7.44-10.3-4.08 0-6 2.25t-1.91 7.32V70c0 3.66.61 6.26 1.83 7.82s3.16 2.39 5.93 2.39ZM321.16 81.67H319V48.24h2.13ZM328.24 51.82c0-1.37.45-2.06 1.35-2.06a1.2 1.2 0 0 1 1 .54 2.65 2.65 0 0 1 .38 1.52 2.7 2.7 0 0 1-.38 1.53 1.2 1.2 0 0 1-1 .56c-.9 0-1.35-.7-1.35-2.09m2.42 29.85h-2.12V58.31h2.12ZM352.53 75.59a5.55 5.55 0 0 1-2.39 4.82 11.63 11.63 0 0 1-6.77 1.69 16.1 16.1 0 0 1-7.43-1.44v-2.3a16.5 16.5 0 0 0 7.43 1.76 9.8 9.8 0 0 0 5.26-1.12 3.51 3.51 0 0 0 1.79-3.06 3.75 3.75 0 0 0-1.43-3 15.7 15.7 0 0 0-4.69-2.36 26 26 0 0 1-4.92-2.18 6.8 6.8 0 0 1-2.14-2.06 5.2 5.2 0 0 1-.72-2.81 4.77 4.77 0 0 1 2.2-4.14 10.7 10.7 0 0 1 6.16-1.53 18.3 18.3 0 0 1 7.17 1.42l-.79 1.93a16.9 16.9 0 0 0-6.38-1.42 9.26 9.26 0 0 0-4.54 1 2.9 2.9 0 0 0-1.67 2.62 3.61 3.61 0 0 0 1.3 2.92 18 18 0 0 0 5.08 2.45 26 26 0 0 1 4.6 2 6.65 6.65 0 0 1 2.16 2.08 5.05 5.05 0 0 1 .72 2.73M374.39 81.67V66.52q0-3.52-1.49-5.12a6 6 0 0 0-4.59-1.61c-2.8 0-4.84.71-6.14 2.12s-1.94 3.7-1.94 6.87v12.89h-2.13V48.24h2.13v10.63l-.11 3h.15a7.8 7.8 0 0 1 3.31-3 11.6 11.6 0 0 1 5-1q7.95 0 7.95 8.53v15.27ZM412.79 81.67V66.35q0-3.42-1.33-5a5.08 5.08 0 0 0-4.08-1.57c-2.4 0-4.16.66-5.31 2s-1.72 3.39-1.72 6.21v13.68h-2.17v-16q0-5.91-5.41-5.91c-2.45 0-4.24.72-5.35 2.14s-1.68 3.71-1.68 6.85v12.92h-2.13V58.31h1.77l.45 3.2h.17a6.66 6.66 0 0 1 2.75-2.69 8.14 8.14 0 0 1 3.93-1q5.52 0 7.09 4.15h.08a7.9 7.9 0 0 1 3.07-3.07 8.74 8.74 0 0 1 4.37-1.08q3.83 0 5.73 2c1.28 1.36 1.92 3.53 1.92 6.49v15.36ZM431.45 82.1a10.19 10.19 0 0 1-7.94-3.1q-2.85-3.13-2.85-8.79a13.73 13.73 0 0 1 2.75-9 9.1 9.1 0 0 1 7.42-3.36 8 8 0 0 1 6.51 2.88 11.9 11.9 0 0 1 2.38 7.82v1.72H422.9q0 4.81 2.24 7.35a7.9 7.9 0 0 0 6.31 2.53 19 19 0 0 0 3.51-.28 20.6 20.6 0 0 0 3.84-1.2v1.93a16.4 16.4 0 0 1-3.66 1.17 20 20 0 0 1-3.69.33m-.62-22.35a7 7 0 0 0-5.42 2.25 10.5 10.5 0 0 0-2.41 6.39h14.44A10.16 10.16 0 0 0 435.7 62a5.79 5.79 0 0 0-4.87-2.25M462 81.67V66.52q0-3.52-1.48-5.12a6 6 0 0 0-4.6-1.61c-2.79 0-4.84.71-6.13 2.12s-1.95 3.7-1.95 6.87v12.89h-2.12V58.31h1.8l.41 3.2h.13q2.28-3.65 8.1-3.65 7.95 0 7.95 8.53v15.28ZM477.41 80.21a16 16 0 0 0 3.52-.35v1.72a11.4 11.4 0 0 1-3.57.52 5.81 5.81 0 0 1-4.56-1.66q-1.47-1.65-1.47-5.2V60.16h-3.46v-1.25l3.46-1 1.07-5.29h1.1v5.65h6.85v1.85h-6.85v14.82a6.77 6.77 0 0 0 .94 4 3.44 3.44 0 0 0 2.97 1.27M500 75.59a5.55 5.55 0 0 1-2.39 4.82 11.6 11.6 0 0 1-6.76 1.69 16.16 16.16 0 0 1-7.44-1.44v-2.3a16.5 16.5 0 0 0 7.44 1.76 9.8 9.8 0 0 0 5.27-1.12 3.51 3.51 0 0 0 1.79-3.06 3.72 3.72 0 0 0-1.43-3 15.6 15.6 0 0 0-4.69-2.36 26 26 0 0 1-4.92-2.18 6.8 6.8 0 0 1-2.14-2.06 5.2 5.2 0 0 1-.72-2.81 4.8 4.8 0 0 1 2.2-4.14 10.7 10.7 0 0 1 6.16-1.53 18.4 18.4 0 0 1 7.18 1.42l-.8 1.93a16.9 16.9 0 0 0-6.38-1.42 9.2 9.2 0 0 0-4.53 1 2.9 2.9 0 0 0-1.68 2.62 3.61 3.61 0 0 0 1.3 2.92 18.1 18.1 0 0 0 5.08 2.45 25.6 25.6 0 0 1 4.6 2 6.65 6.65 0 0 1 2.16 2.08 5.05 5.05 0 0 1 .7 2.73",
    style: {
      fill: "#fff"
    }
  }))));
};
export default SvgAuth;